/**
 * Action types for SNMP functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_SNMP_LIST = 'GET_SNMP_LIST';
export const GET_SNMP_LIST_SUCCESS = 'GET_SNMP_LIST_SUCCESS';
export const GET_SNMP_LIST_FAIL = 'GET_SNMP_LIST_FAIL';
export const DELETE_SNMP = 'DELETE_SNMP';
export const DELETE_SNMP_SUCCESS = 'DELETE_SNMP_SUCCESS';
export const DELETE_SNMP_FAIL = 'DELETE_SNMP_FAIL';
export const ADD_SNMP = 'ADD_SNMP';
export const ADD_SNMP_COMPLETE =  'ADD_SNMP_COMPLETE';
export const EDIT_SNMP = 'EDIT_SNMP'
export const EDIT_SNMP_COMPLETE =  'EDIT_SNMP_COMPLETE'